import { Capacitor } from '@capacitor/core';

// PWA installée sur l'écran d'accueil (Android/iOS "Ajouter à l'écran d'accueil"),
// lancée sans la barre d'adresse du navigateur.
function detectStandalonePwa(): boolean {
  if (window.matchMedia?.('(display-mode: standalone)').matches) return true;
  // iOS Safari n'expose pas display-mode: standalone de façon fiable avant iOS 16.4.
  return (window.navigator as any).standalone === true;
}

// true dans l'app packagée Capacitor (Android/iOS) OU dans la PWA installée sur l'écran
// d'accueil — jamais dans un simple onglet de navigateur.
export const isAppShell = Capacitor.isNativePlatform() || detectStandalonePwa();

export function useNativeApp() {
  return { isAppShell };
}
